import React from "react";

function Navbar() {
  return (
    <>
      {/* <nav role="navigation" className="nav_menu aiiroxnavmenu w-nav-menu">
        <a href="./index.html" className="nav_link w-nav-link">
          Home
        </a>
        <a href="./features.html" className="nav_link w-nav-link">
          Features
        </a>
        <a href="./pricing.html" className="nav_link w-nav-link">
          Pricing
        </a>
        <a href="./about-aiiro.html" className="nav_link w-nav-link">
          About aiiro
        </a>
        <a
          href="./get-in-touch.html"
          className="nav_link last_item_burger w-nav-link"
        >
          Get in touch
        </a>
        <a
          href="https://app.aiiro.ai/en/auth/login"
          className="nav_link last_item_burger mob_button_1 mobile_button button_line w-nav-link"
        >
          Log in
        </a>
        <div className="button_mobile_container">
          <a
            href="https://app.aiiro.ai/en/auth/signup"
            className="mobile_button w-button"
          >
            Sign up
          </a>
        </div>
      </nav> */}
      <div className="w-layout-hflex buttons">
        <div className="nav_button-wrapper">
          <a
            href="https://www.aiiro.ai/"
            target="_blank"
            rel="noreferrer"
            className="button w-button"
          >
            Visit aiiro
          </a>
        </div>
      </div>
    </>
  );
}

export default Navbar;
